import { ParkAreaAssesmentStatus } from '@services/park-area-assesment/park-area-assesment-status.enum';

export const ASSESMENT_STATUS_COLOR_MAP: Record<ParkAreaAssesmentStatus, string> = {
	[ParkAreaAssesmentStatus.NOT_STARTED]: 'grey.500',
	[ParkAreaAssesmentStatus.PASSED]: 'success.main',
	[ParkAreaAssesmentStatus.PARTIALLY_PASSED]: 'warning.main',
	[ParkAreaAssesmentStatus.NOT_PASSED]: 'error.main'
};
